/**
 * "Instalar" an agent with one click (docs/refactor/51, N3), desktop only: the agent's own official
 * installer, run by the app (src-tauri/src/agent_install.rs), with what it prints streamed back here.
 */

import { invoke } from '@tauri-apps/api/core'
import { listen, type UnlistenFn } from '@tauri-apps/api/event'
import type { LocalAgentId } from './localAgent'

export interface AgentInstallEvent {
  agent: LocalAgentId
  line: string | null
  done: boolean
  ok: boolean
}

/** Resolves once installed; rejects with `npm-not-installed` (Codex with no Node) or `install-failed`. */
export const agentInstall = (agent: LocalAgentId) => invoke<void>('agent_install', { agent })

export function onAgentInstall(handler: (event: AgentInstallEvent) => void): Promise<UnlistenFn> {
  return listen<AgentInstallEvent>('devpulse://agent-install', (event) => handler(event.payload))
}

/** Which agents the app installs by itself. */
export const INSTALLABLE: LocalAgentId[] = ['claude', 'codex']
